import { render, staticRenderFns } from "./AppsIcon.vue?vue&type=template&id=50a2bc18"
import script from "./AppsIcon.vue?vue&type=script&lang=js"
export * from "./AppsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports